import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import axios from '../config/axios';
import '../styles/Dashboard.css';

function DeviceList() {
  const { token, signOut, user } = useAuth();
  const navigate = useNavigate();
  const [devices, setDevices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDevices();
  }, []);

  const fetchDevices = async () => {
    try {
      const response = await axios.get('/devices');
      setDevices(response.data);
    } catch (error) {
      console.error('Error fetching devices:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    signOut();
    navigate('/login');
  };

  if (loading) {
    return <div className="loading">Loading devices...</div>;
  }

  return (
    <div className="device-list-container">
      <nav className="dashboard-nav">
        <div className="nav-left">
          <button onClick={() => navigate('/dashboard')} className="back-btn">
            ← Dashboard
          </button>
          <h1>My Devices</h1>
        </div>
        <div className="nav-actions">
          <span className="user-name">{user?.email || user?.name || 'User'}</span>
          <button onClick={handleLogout} className="logout-btn">Logout</button>
        </div>
      </nav>
      
      <div className="devices-grid">
        {devices.map(device => (
          <Link to={`/device/${device.deviceId}`} key={device.deviceId} className="device-card">
            <h3>{device.name}</h3>
            <p className="device-id">ID: {device.deviceId}</p>
            <p className="device-type">Type: {device.type}</p>
            <p className={`device-status ${device.status}`}>
              Status: {device.status || 'unknown'}
            </p>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default DeviceList;

